import { render, staticRenderFns } from "./UipSetting.vue?vue&type=template&id=49b65222&scoped=true"
import script from "./UipSetting.vue?vue&type=script&lang=js"
export * from "./UipSetting.vue?vue&type=script&lang=js"
import style0 from "./UipSetting.vue?vue&type=style&index=0&id=49b65222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b65222",
  null
  
)

export default component.exports